import { render } from "./ordemServicoView.vue?vue&type=template&id=4756a056&scoped=true"
import script from "./ordemServicoView.vue?vue&type=script&lang=js"
export * from "./ordemServicoView.vue?vue&type=script&lang=js"

import "./ordemServicoView.vue?vue&type=style&index=0&id=4756a056&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4756a056"]])

export default __exports__